import React from 'react';

interface ChipProps {
  label: string;
  color: string;
}

// The function is now written as an implicit return, removing the 'return' statement
const Chip: React.FC<ChipProps> = ({ label, color }) => (
  <div
    style={{
      display: 'inline-block',
      padding: '5px 15px',
      borderRadius: '20px',
      backgroundColor: color,
      color: 'white',
      fontSize: '14px',
      fontWeight: 'bold',
    }}
  >
    {label}
  </div>
);

export default Chip;
